import React, { Component } from 'react';
import { Field } from 'formik';
import { withAsyncActions } from 'react-async-client';
import * as yup from 'yup';

import ModalForm, { modalFormPropTypes } from 'components/common/ModalForm';
import Input from 'components/common/form/Input';
import SearchSelect from 'components/common/form/SearchSelect';
import {
    postCity,
    putCity,
    getRegions,
    formAutoOptions,
} from 'actions/asyncActions';
import NumberInput from '../../common/form/NumberInput';

const validationSchema = yup.object().shape({
    name: yup.string().trim().required(),
});

@withAsyncActions({
    postAction: postCity,
    putAction: putCity
}, formAutoOptions)
export default class CityModal extends Component {
    static propTypes = modalFormPropTypes;

    renderForm = formProps => {
        return (
            <div>
                <Field
                    name='name'
                    component={Input}
                    label='Название:'
                    placeholder='Введите название' />
                <Field
                    name='region'
                    component={SearchSelect}
                    label='Регион'
                    action={getRegions}
                />
                <Field
                    name='timeZoneOffset'
                    component={NumberInput}
                    label='Часовой пояс (в минутах)'
                />
            </div>
        );
    }

    render() {
        return (
            <ModalForm
                {...this.props}
                createTitle={'Добавить город'}
                editTitle={'Редактировать город'}
                validationSchema={validationSchema}
                renderForm={this.renderForm}
            />
        );
    }
}
